import { Grid, Paper } from '@mui/material';
import { useSnackbar } from 'notistack';
import { SubmitHandler } from 'react-hook-form';
import { useMutation } from 'react-query';
import { useNavigate, useParams } from 'react-router';
import * as api from '../../api/app/monitoredCycleTimeApi';
import { AssetFullPathHeader } from '../../components/core/AssetFullPathHeader/AssetFullPathHeader';
import { PageContent } from '../../components/core/PageContent/PageContent';
import { AssetDetailTabValues, MonitoredPanelValues } from '../../types/app/asset.types';
import { MonitoredCycleTimeInputs } from '../../types/app/monitoredCycleTime.types';
import { dictionary } from '../../utils/core/dictionary';
import { paths } from '../../utils/core/routes';
import { MonitoredCycleTimeForm } from './MonitoredCycleTimeForm';
import { useStyles } from './MonitoredCycleTimeForm.styles';

export function MonitoredCycleTimeCreate() {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const { parentId } = useParams();
  const { mutate: mutateCreateMonitoredCycleTime } = useMutation(api.createMonitoredCycleTime);

  const handleOnSubmit: SubmitHandler<MonitoredCycleTimeInputs> = (
    data: MonitoredCycleTimeInputs,
  ) => {
    data.parentAssetId = Number(parentId);
    mutateCreateMonitoredCycleTime(
      { ...data },
      {
        onSuccess: () => {
          enqueueSnackbar(dictionary.MONITORED_CYCLE_TIME_CREATED, { variant: 'success' });
          navigate(`${paths.ASSETS_DETAIL}/${parentId}`, {
            state: {
              tabValue: AssetDetailTabValues.MONITORED_VALUES,
              panelValue: MonitoredPanelValues.MONITORED_CYCLE,
            },
          });
        },
        onError: (result: any) => {
          enqueueSnackbar(`${result}`, { variant: 'error' });
        },
      },
    );
  };
  return (
    <>
      <AssetFullPathHeader
        finalTitle={dictionary.MONITORED_CYCLE_TIME_CREATE}
        parentId={Number(parentId)}
      />
      <PageContent>
        <Grid container spacing={1}>
          <Grid item xs={12} md={8} lg={4}>
            <Paper className={classes.paper}>
              <MonitoredCycleTimeForm
                onSubmit={handleOnSubmit}
                onBack={() =>
                  navigate(`${paths.ASSETS_DETAIL}/${parentId}`, {
                    state: {
                      tabValue: AssetDetailTabValues.MONITORED_VALUES,
                      panelValue: MonitoredPanelValues.MONITORED_CYCLE,
                    },
                  })
                }
              />
            </Paper>
          </Grid>
        </Grid>
      </PageContent>
    </>
  );
}
